import { createFileRoute } from '@tanstack/react-router';
import { PRIVACY } from '../content/legal.js';
import { LegalDocument, legalHead } from '../components/site/LegalDocument.js';

/**
 * `/privacy-policy`
 *
 * The live document, not a rewrite. The path is one of the three legal URLs
 * already in the index and linked from every footer, so it has to keep both
 * its address and its words.
 */
export const Route = createFileRoute('/privacy-policy')({
  head: () => legalHead(PRIVACY),
  component: () => <LegalDocument doc={PRIVACY} />,
});
